import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=0afa49ea&scoped=true"
import script from "./recent.vue?vue&type=script&lang=ts"
export * from "./recent.vue?vue&type=script&lang=ts"
import style0 from "./recent.vue?vue&type=style&index=0&id=0afa49ea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa49ea",
  null
  
)

/* custom blocks */
import block0 from "./recent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports